export enum ExternalRole {
    Administrator = 1,
    UserNBRB = 2,
    MaintenanceSpecialist = 3,
    Guest = 4,
}


// WEBPACK FOOTER //
// ./common/enums/ExternalRole.ts